import template from './pepperAssetFinanceAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
controller: class controller {
    constructor($mdDialog) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      this.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            controller() {
              const self = this;
              self.merchantId = '';

              self.confirm = () => {
                $mdDialog.hide(self.merchantId);
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = (changes) => {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = () => {};
    }
  }
};
